import {
	Button,
	ButtonProps,
	styled,
	Typography,
	useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/system';
import { useNavigate } from 'react-router-dom';

type Props = ButtonProps & {
	label: string;
	to: string;
};

const StyledButton = styled(Button)(({ theme }) => ({
	maxWidth: '420px',
	border: '1px solid transparent',
	borderRadius: '4px',
	'&:hover': {
		border: `1px solid ${theme.palette.primary1.main}`,
	},
}));

const HomeButton: React.FC<Props> = props => {
	const navigate = useNavigate();
	const theme = useTheme();
	const desktop = useMediaQuery(theme.breakpoints.up('lg'));

	return (
		<StyledButton
			{...props}
			disableElevation
			disableFocusRipple
			disableTouchRipple
			disableRipple
			variant="home"
			type="button"
			onClick={() => navigate(props.to)}
		>
			<Typography variant={!!desktop ? 'bodyLink' : 'value1'}>
				{props.label}
			</Typography>
		</StyledButton>
	);
};

export default HomeButton;
